// §42 — colour / material / condition / brand (and the bag size) come from the canonical registry
import { CLASS_OF_ACCESSORY_SECTION, CLASS_OF_ACCESSORY_SUBCATEGORY, fieldsForClass } from "../fashionAttributes";

export const ACCESSORY_GENDERS = ["Жінкам", "Чоловікам", "Унісекс / Для всіх"];

const ACCESSORY_SECTIONS_BASE = [
  "Голова / Обличчя",
  "Головні убори",
  "Вуха",
  "Шия — прикраси",
  "Шарфи і хустки",
  "Краватки та метелики",
  "Руки — прикраси",
  "Ремені та пояси",
  "Щиколотки / Ноги",
  "Сумки та рюкзаки",
  "Гаманці та портмоне",
  "Парасолі",
  "Інше",
];

const sectionsByGender = (gender) =>
  gender === "Чоловікам"
    ? ACCESSORY_SECTIONS_BASE.filter((s) => s !== "Щиколотки / Ноги")
    : ACCESSORY_SECTIONS_BASE;

const getSubcatsBySection = (section) => {
  switch (section) {
    case "Голова / Обличчя":
      return [
        "Сонцезахисні окуляри",
        "Оправи / Оптичні окуляри",
        "Аксесуари для окулярів",
        "Аксесуари для волосся (обручі / заколки)",
      ];

    case "Головні убори":
      return [
        "Шапки",
        "Комплекти (шапка+шарф/бафф)",
        "Бейсболки / Кепки",
        "Капелюхи",
        "Панами",
        "Повʼязки на голову",
        "Берети",
        "Бандани",
        "Балаклави",
        "Навушники (утеплювачі на вуха)",
      ];

    case "Вуха":
      return ["Сережки", "Кафи / Манжети", "Сережки для пірсингу"];

    case "Шия — прикраси":
      return ["Кольє і намиста", "Чокери", "Ланцюжки", "Підвіски / Кулони"];

    case "Шарфи і хустки":
      return ["Шарфи", "Хустки", "Баффи", "Шалі", "Комплекти (шапка+шарф)"];

    case "Краватки та метелики":
      return ["Краватки", "Метелики", "Затискач для краватки"];

    case "Руки — прикраси":
      return [
        "Браслети",
        "Кільця і персні",
        "Брошки",
        "Запонки",
        "Годинники",
        "Ремінці для годинника",
        "Органайзери / Коробки для годинників",
        "Рукавички",
      ];

    case "Ремені та пояси":
      return ["Ремені", "Пояси", "Підтяжки", "Пряжки для ременя"];

    case "Щиколотки / Ноги":
      return ["Анклети"];

    case "Сумки та рюкзаки":
      return [
        "Сумки",
        "Рюкзаки",
        "Бананки (поясні)",
        "Крос-боді",
        "Шопери",
        "Органайзери",
        "Валізи",
        "Дорожні сумки",
        "Спортивні сумки",
        "Спортивні рюкзаки",
        "Пляжні сумки",
        "Барсетки",
        "Портфелі",
        "Аксесуари для сумок",
        "Косметички",
      ];

    case "Гаманці та портмоне":
      return ["Гаманці", "Портмоне", "Картхолдери", "Затискачі для грошей", "Органайзери"];

    case "Парасолі":
      return [];

    case "Інше":
      return ["Брелоки", "Обкладинки для документів", "Захисні маски для обличчя"];

    default:
      return [];
  }
};

export const accessoriesFields = (attrs) => {
  const a = attrs || {};
  const gender = a.gender || "";
  const section = a.section || "";

  const genderOnly = [
    {
      name: "gender",
      label: "Стать / Для кого *",
      type: "select",
      options: ACCESSORY_GENDERS,
      required: true,
    },
  ];
  if (!gender) return genderOnly;

  const sectionOnly = [
    ...genderOnly,
    {
      name: "section",
      label: "Розділ",
      type: "select",
      options: sectionsByGender(gender),
      required: false,
    },
  ];
  if (!section) return sectionOnly;

  const subcats = getSubcatsBySection(section);

  const cls = CLASS_OF_ACCESSORY_SUBCATEGORY[a.subcategory] || CLASS_OF_ACCESSORY_SECTION[section] || "accessory";
  const canonical = fieldsForClass(cls, a);

  if (!subcats || subcats.length === 0) return [...sectionOnly, ...canonical];

  return [
    ...sectionOnly,
    {
      name: "subcategory",
      label: "Підкатегорія",
      type: "select",
      options: subcats,
      required: false,
    },
    ...canonical,
  ];
};
